// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ySWavqZ7PrxapI {
  box-sizing: border-box;
  min-width: 95px;
  height: 32px;
  margin: 4px 0 2px 8px;
  padding: 7px 9px;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"WorkspaceBoardsButton": `ySWavqZ7PrxapI`
};
export default ___CSS_LOADER_EXPORT___;
